import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    }
});

const GradinCategoryForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Product"
                                value={values.Product}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Product && touched.Product)}
                                placeholder={translations["grading_product"] || "Product"}
                                label={translations["grading_product"] || "Product"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(GradinCategoryForm);
